import { isProfileNavItemActive } from "./profileNavRegistry";

// SECURITY: `allowed` must already be permission-filtered - this only looks items
// up inside it, so configuration can never expose a tab the user may not see.
export function resolveProfileNav(allowed, config) {
  const allowedItems = Array.isArray(allowed) ? allowed : [];

  if (!isUsableConfig(config)) {
    return { bar: allowedItems, more: [] };
  }

  const byKey = new Map(allowedItems.map((item) => [item.key, item]));
  const used = new Set();

  const take = (keys) =>
    (Array.isArray(keys) ? keys : []).reduce((acc, key) => {
      const item = byKey.get(key);
      if (item && !used.has(key)) {
        used.add(key);
        acc.push(item);
      }
      return acc;
    }, []);

  const bar = take(config.bar);
  const more = take(config.more);

  // Tabs added after a config was saved fall under More instead of disappearing.
  const unplaced = allowedItems.filter((item) => !used.has(item.key));

  // Never render an empty navigation.
  if (!bar.length) {
    return { bar: allowedItems, more: [] };
  }

  return { bar, more: [...more, ...unplaced] };
}

function isUsableConfig(config) {
  return !!(
    config &&
    typeof config === "object" &&
    config.configured === true &&
    Array.isArray(config.bar)
  );
}

export function isAnyProfileNavItemActive(items, routeName) {
  return (Array.isArray(items) ? items : []).some((item) =>
    isProfileNavItemActive(item, routeName)
  );
}

export { isProfileNavItemActive };
